import React from 'react'
import { HStack, Radio, Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import CreditCardBrandsImage from '@images/external_payment/credit_card_brands.webp'

export const CreditCardOption = ({ isSelected, onChange }) => (
  <HStack w="100%" p="16px" align="flex-start" spacing={3} cursor="pointer" onClick={onChange}>
    <Radio isChecked={isSelected} colorScheme="red" size="lg" mt="2px" />
    <Image w="212px" h="23px" src={buildAssetUrlString(CreditCardBrandsImage)} alt="VISA, Mastercard, JCB, Discover, Diners, AMEX" objectFit="contain" />
  </HStack>
)
